import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { GetPropertiesTestRequestParams, ResponseData } from "../common"

interface PropertyRequestData {
  type: "mobile" | "desktop" | "all"
}

export interface GetHeroBannerDataRequest extends Partial<AxiosRequestConfig> {
  params: PropertyRequestData
}

export type HeroBannerSchema = {
  awsUrl: string
  order: number
  type: "Mobile" | "Desktop"
  isDelete: boolean
  isClickable: boolean
  title: string
  propertyUrl: string
  propertyUrlType: string
  searchParameters?: GetPropertiesTestRequestParams
  city: string
  state: string
  country: string
  altText?: string
}

export interface GetHeroBannerDataResponseData extends ResponseData {
  data: HeroBannerSchema[]
}

export interface GetHeroBannerDataResponse extends AxiosResponse {
  data: GetHeroBannerDataResponseData
}

export function getHeroBannerDataAPI(
  { params }: GetHeroBannerDataRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    params,
    // data: { avoidClientSideAuth: true },
    method: "get",
    url: "/home/hero-banner/all",
  }) as Promise<GetHeroBannerDataResponse>
}
